import { ListProps, TextField } from 'react-admin';

import {
  Forbidden,
  Grid,
  GridList,
  TextInput,
} from '@components';
import { CropStateActions } from './CropStateActions';
import { useExporter, useRbacEdit, useRbacList } from '@hooks';
import { statesByCode, statesByCodeKeys } from '@types';

export const CropStateList = (props: ListProps) => {
  const rbacList = useRbacList();
  const rbacEdit = useRbacEdit();

  const stateProps = statesByCodeKeys.reduce((obj, stateCode) => {
    const prop = `state${stateCode}`;
    obj[prop] = { label: statesByCode[stateCode] };
    return obj;
  }, {});

  const exporter = useExporter({
    filename: 'Crop State matrix',
    props: {
      'nameMx': {
        label: 'Crop',
      },
      ...stateProps,
    },
  });

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList
      {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
      exporter={exporter}
      editComponent={rbacEdit ? <CropStateActions /> : undefined}
      hideOptionsButton
    >
      <Grid
        rowClick={false}
        defaultColumns={[
          'nameMx',
          ...statesByCodeKeys.map(stateCode => `state${stateCode}`),
        ]}
      >
        <TextField source="nameMx" label="Crop" />
        <TextField source="stateAGU" label={statesByCode['AGU']} />
        <TextField source="stateBCN" label={statesByCode['BCN']} />
        <TextField source="stateBCS" label={statesByCode['BCS']} />
        <TextField source="stateCAM" label={statesByCode['CAM']} />
        <TextField source="stateCHP" label={statesByCode['CHP']} />
        <TextField source="stateCHH" label={statesByCode['CHH']} />
        <TextField source="stateCOA" label={statesByCode['COA']} />
        <TextField source="stateCOL" label={statesByCode['COL']} />
        <TextField source="stateDUR" label={statesByCode['DUR']} />
        <TextField source="stateGUA" label={statesByCode['GUA']} />
        <TextField source="stateGRO" label={statesByCode['GRO']} />
        <TextField source="stateHID" label={statesByCode['HID']} />
        <TextField source="stateJAL" label={statesByCode['JAL']} />
        <TextField source="stateCMX" label={statesByCode['CMX']} />
        <TextField source="stateMIC" label={statesByCode['MIC']} />
        <TextField source="stateMOR" label={statesByCode['MOR']} />
        <TextField source="stateMEX" label={statesByCode['MEX']} />
        <TextField source="stateNAY" label={statesByCode['NAY']} />
        <TextField source="stateNLE" label={statesByCode['NLE']} />
        <TextField source="stateOAX" label={statesByCode['OAX']} />
        <TextField source="statePUE" label={statesByCode['PUE']} />
        <TextField source="stateQUE" label={statesByCode['QUE']} />
        <TextField source="stateROO" label={statesByCode['ROO']} />
        <TextField source="stateSLP" label={statesByCode['SLP']} />
        <TextField source="stateSIN" label={statesByCode['SIN']} />
        <TextField source="stateSON" label={statesByCode['SON']} />
        <TextField source="stateTAB" label={statesByCode['TAB']} />
        <TextField source="stateTAM" label={statesByCode['TAM']} />
        <TextField source="stateTLA" label={statesByCode['TLA']} />
        <TextField source="stateVER" label={statesByCode['VER']} />
        <TextField source="stateYUC" label={statesByCode['YUC']} />
        <TextField source="stateZAC" label={statesByCode['ZAC']} />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" label="Search" alwaysOn style={{ width: 200 }} />,
];
